// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nfieldset[data-v-69af6aa5] {\n\ttext-align: center;\n}\ninput[type=submit][data-v-69af6aa5] {\n\tmargin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
